import { colorProp, highContrastProp } from '../helpers';
const contentSizes = ['1', '2'];
const contentVariants = ['solid', 'soft'];
const baseMenuContentPropDefs = {
    size: { type: 'enum', values: contentSizes, default: '2', responsive: true },
    variant: { type: 'enum', values: contentVariants, default: 'solid' },
    color: colorProp,
    highContrast: highContrastProp,
};
const baseMenuItemPropDefs = {
    color: colorProp,
    shortcut: { type: 'string', default: undefined },
};
const baseMenuCheckboxItemPropDefs = {
    shortcut: { type: 'string', default: undefined },
};
export { baseMenuContentPropDefs, baseMenuItemPropDefs, baseMenuCheckboxItemPropDefs };
//# sourceMappingURL=base-menu.props.js.map